import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../guard/auth.guard'
import { ReporteCostosComponent } from './reporte-costos/reporte-costos.component'
import { ReporteStockComponent } from './reporte-stock/reporte-stock.component'
import { ReportesComponent } from './reportes.component'

const routes: Routes = [
  {
    path: '',
    component: ReportesComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: ReporteStockComponent },
      {
        path: 'costos',
        canActivate: [AuthGuard],
        component: ReporteCostosComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportesRoutingModule {}
